import { render, staticRenderFns } from "./ClosureDates.vue?vue&type=template&id=4ab1d591&scoped=true&"
import script from "./ClosureDates.vue?vue&type=script&lang=js&"
export * from "./ClosureDates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab1d591",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tommy/Documents/BrocheBallet/studio-manager/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ab1d591')) {
      api.createRecord('4ab1d591', component.options)
    } else {
      api.reload('4ab1d591', component.options)
    }
    module.hot.accept("./ClosureDates.vue?vue&type=template&id=4ab1d591&scoped=true&", function () {
      api.rerender('4ab1d591', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/ClosureDates.vue"
export default component.exports